// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__HbDoe","info":"Note_info__3Yitt","note":"Note_note__3x49j","actions":"Note_actions__3IExz"};